import { PermissionsState, ActionTypes, Action } from './types';

const INITIAL_STATE: PermissionsState = {
  allowed_drugstores: [],
  user: {
    id: 0,
    email: '',
    first_name: '',
    last_name: '',
    name: '',
  },
  error: false,
  loading: true,
};

export default function reducer(state = INITIAL_STATE, action: Action): PermissionsState {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        ...action.permissions,
      };

    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };

    default:
      return state;
  }
}
